export default __webpack_public_path__ + "static/media/kclogo.08c2e2c5.png";